$(function() {
  const resizeEvent = () => {
    var windowWidth = $(window).width();
    // 画面幅が1050px以上であれば無効化
    if(windowWidth > 1050){
      $.scrollify.enable();
      // トップセクションのヘッダー調整
      const announceBarHeight = document.getElementById('shopify-section-announcement-bar') ? document.getElementById('shopify-section-announcement-bar').clientHeight : 0,
        headerHeight = document.getElementById('shopify-section-header') ? document.getElementById('shopify-section-header').clientHeight : 0,
        breadcrumb = document.querySelector('.c-breadcrumb').clientHeight;
      const headerSectionHeight = announceBarHeight + headerHeight + breadcrumb;

      document.querySelector('.c-history-section--main .banner__content').style.maxHeight = (window.innerHeight - headerSectionHeight) + "px";
    }else{
      $.scrollify.disable();
      document.querySelectorAll('.c-history-section').forEach(section => {
        section.style.height = 'auto';
      })
    }
  }
  $.scrollify({
    section : ".c-history-section",
    sectionName : ".c-history-section",
    interstitialSection:"#shopify-section-footer",
    standardScrollElements: "#shopify-section-announcement-bar,#shopify-section-header,#shopify-section-footer",
    easing : 'easeInOutCubic',
    scrollSpeed : 800,
    afterResize:function() {
      resizeEvent()
    },
    afterRender:function() {
      resizeEvent()
    },
  });
});
